module.exports = __webpack_public_path__ + "img/brewery_logo_latchkey.8fb6b8be.jpg";